import * as React from 'react'

import Button           from '@material-ui/core/Button/Button'
import Grid             from '@material-ui/core/Grid/Grid'
import Hidden           from '@material-ui/core/Hidden/Hidden'
import AddIcon          from '@material-ui/icons/Add'
import FileDownloadIcon from '@material-ui/icons/FileDownload'

import { ActionButton } from '../atoms'
import DownloadExport   from '../organisms/DownloadExport'

const CompaniesBar = ({
  onAddClick,
  exportRequest,
}) => {
  return (
    <Grid
      container
      spacing={16}
      justify={'flex-end'}
      alignItems={'center'}
    >
      <Grid item>
        <DownloadExport
          fileName={'companies.xlsx'}
          fileRequest={exportRequest}
        >
          {({ loaded }) => (
            <>
              <Hidden xsDown>
                <ActionButton
                  disabled={!loaded}
                  color={'secondary'}
                  actionType={'download'}
                  variant={'raised'}
                />
              </Hidden>
              <Hidden smUp>
                <Button
                  disabled={!loaded}
                  color={'secondary'}
                  variant={'raised'}
                >
                  <FileDownloadIcon />
                </Button>
              </Hidden>
            </>
          )}
        </DownloadExport>
      </Grid>
      <Grid item>
        <Hidden xsDown>
          <ActionButton
            color={'primary'}
            onClick={onAddClick}
            actionType={'add'}
            variant={'raised'}
          />
        </Hidden>
        <Hidden smUp>
          <Button
            color={'primary'}
            onClick={onAddClick}
            variant={'raised'}
          >
            <AddIcon />
          </Button>
        </Hidden>
      </Grid>
    </Grid>
  )
}

export default CompaniesBar



// WEBPACK FOOTER //
// ./src/components/molecules/CompaniesBar.tsx